export const buildMccOptions = (mccCodes) => {
  if (!Array.isArray(mccCodes)) return [];

  const seen = new Set();
  return mccCodes
    .filter((entry) => entry && entry.id && entry.code && entry.code !== '0')
    .map((entry) => {
      const description = entry.description || entry.category || '';
      return {
        value: String(entry.id),
        code: String(entry.code),
        label: description ? `${entry.code} - ${description}` : String(entry.code),
      };
    })
    .filter((option) => {
      if (seen.has(option.value)) return false;
      seen.add(option.value);
      return true;
    })
    .sort((a, b) => a.label.localeCompare(b.label, 'pt-BR'));
};

export const resolveMccValue = (mccOptions, storedValue) => {
  if (storedValue === null || storedValue === undefined || storedValue === '') return undefined;

  const stored = String(storedValue).trim();
  if (!stored) return undefined;

  const byId = mccOptions.find((option) => option.value === stored);
  if (byId) return byId.value;

  const byCode = mccOptions.find((option) => option.code === stored);
  return byCode ? byCode.value : undefined;
};
